import * as React from "react";
const SvgFiRrMarsStrokeRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m23.145 9.903-2.414-2.586a1.001 1.001 0 0 0-1.462 1.366L21.433 11H17V9a1 1 0 0 0-2 0v2h-1.08C13.432 7.613 10.519 5 7 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c3.519 0 6.432-2.613 6.92-6H15v2a1 1 0 0 0 2 0v-2h4.432l-2.163 2.317a1.001 1.001 0 0 0 1.462 1.366l2.39-2.561A2.98 2.98 0 0 0 24 12c0-.802-.312-1.555-.855-2.097M7 17c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5"
    />
  </svg>
);
export default SvgFiRrMarsStrokeRight;
